import React, { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// Utils
import useImage from '../../../src/hooks/useImage';

// Components
import ImagesSlider from '../ImagesSlider/ImagesSlider';
import LightboxImages from '../LightboxImages/LightboxImages';

import styles from './MobileSlidesBanner.module.scss';

function MobileSlidesBanner({ slides }) {
  const lightboxRef = useRef();

  const { getImageSrc } = useImage();

  const [currentIndex, setCurrentIndex] = useState(1);

  const slidesImages = useMemo(() => (
    slides?.length ? slides.map((slide) => (
      getImageSrc({
        fileId: slide.path,
        widths: {
          default: 768,
        },
      })
    )) : []
  ), [slides]);

  return (
    <div className={styles.banner}>
      <button className={styles.slider_opener} type="button" onClick={() => lightboxRef.current.open()}>
        <ImagesSlider
          className={styles.slider}
          images={slidesImages}
          setCurrentIndex={setCurrentIndex}
        />
      </button>

      <div className={styles.counter}>
        {`${currentIndex + 1} / ${slides.length}`}
      </div>

      <LightboxImages
        ref={lightboxRef}
        images={slidesImages}
      />
    </div>
  );
}

MobileSlidesBanner.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({})),
};

MobileSlidesBanner.defaultProps = {
  slides: [],
};

export default MobileSlidesBanner;
